import React, { useEffect } from "react";
import './registeration.css';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import { useNavigate } from "react-router-dom";
import Footer from '../../reusable-components/footer/footer';
import axios from 'axios';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import Snackbar from '@mui/material/Snackbar';
import MuiAlert from '@mui/material/Alert';
import BaseUrl from "../../utils/base-uri.json";
import OutlinedInput from '@mui/material/OutlinedInput';

import { yupResolver } from '@hookform/resolvers/yup';
import { useForm } from 'react-hook-form';
import { Typography } from '@mui/material';
import * as Yup from 'yup';

function Registeration(props) {
    const navigate = useNavigate();
    // const [age, setAge] = React.useState('');
    // const [firstName, setFirstName] = React.useState('');
    // const [lastName, setLastName] = React.useState('');
    // const [contactTitle, setContactTitle] = React.useState('');
    // const [phoneNumber, setPhoneNumber] = React.useState(0);
    // const [email, setEmail] = React.useState('');
    // const [principalCompanyOfficer, setPrincipleCompanyOfficer] = React.useState('');
    const [docType, setDocType] = React.useState([]);
    const [selectedDoctype, setSelectedDoctype] = React.useState('select');
    const [open, setOpen] = React.useState(false);
    // const [lastFour, setLastFour] = React.useState('');
    // const [password, setPassword] = React.useState('');
    // const [confirmPassword, setConfirmPassword] = React.useState('');
    // const [vendorCode, setVendorCode] = React.useState('');
    const [openError, setOpenError] = React.useState(false);
    // const [firstNameError, setFirstNameError] = React.useState('');
    // const [lastNameError, setLastNameError] = React.useState('');
    // const [contactTitleError, setContactTitleError] = React.useState('');
    // const [phoneNumberError, setPhoneNumberError] = React.useState('');
    // const [lastFourError, setLastFourError] = React.useState('');
    // const [emailError, setEmailError] = React.useState('');
    // const [passwordError, setPasswordError] = React.useState('');
    // const [confirmPasswordError, setConfirmPasswordError] = React.useState('');
    // const [vendorCodeError, setVendorCodeError] = React.useState('');



    // const Alert = React.forwardRef(function Alert(props, ref) {
    //     return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
    // });

    useEffect(() => {
        axios.get(BaseUrl.baseUrl + BaseUrl.registration.getDocumentType)
            .then(response => setDocType(response.data.data));
    }, []);

    const handleChange = (event, index) => {
        setSelectedDoctype(event.target.value);
    };

    const validationSchema = Yup.object().shape({
        firstName: Yup.string()
            .required('First name is required !')
            .max(20, 'First name must not exceed 20 characters'),
        lastName: Yup.string()
            .required('Last name is required !')
            .min(6, 'Last name must be at least 6 characters')
            .max(20, 'Last name must not exceed 20 characters'),
        title: Yup.string().
            required('Title is required !')
            .min(6, 'Title must be at least 6 characters')
            .max(20, 'Title must not exceed 20 characters'),
        last4Digits: Yup.string()
            .required('last 4 Digits is required !')
            .min(4, ' 4 Digits of id is required !'),
        email: Yup.string()
            .required('Email Address is required !')
            .email('Email Address is invalid !'),
        number: Yup.string()
            .required('Phone Number is required !')
            .matches(/^[0][1-9]\d{9}$|^[1-9]\d{9}$/, 'format like (0000000000)'),
        createPassword: Yup.string()
            .required('Password is required !'),
        confirmPassword: Yup.string()
            .required('Confirm Password is required !')
            .oneOf([Yup.ref('createPassword'), null], 'Confirm Password does not match'),
        vendorCode: Yup.string()
            .required('Vendor Code is required !')
            .min(6, ' 6 Digits Code is required !'),

    });

    const {
        register,
        handleSubmit,
        formState: { errors }
    } = useForm({
        resolver: yupResolver(validationSchema)
    });

    const onSubmit = (data) => {
        // if (firstName.length == 0 && lastName.length == 0 && contactTitle.length == 0 && lastFour.length == 0 && email.length == 0 && password.length == 0 && confirmPassword.length == 0 && vendorCode.length == 0) {
        //     setFirstNameError("error");
        //     setLastNameError("error");
        //     setContactTitleError("error");
        //     setPhoneNumberError("error");
        //     setLastFourError('error');
        //     setEmailError('error');
        //     setPasswordError('error');
        //     setConfirmPasswordError('error');
        //     setVendorCodeError('error');
        // } else if (lastName.length == 0) {
        //     setLastNameError("error");
        // } else if (contactTitle.length == 0) {
        //     setContactTitleError("error");
        // } else if (phoneNumber.length == 0) {
        //     setPhoneNumberError("error");
        // } else if (lastFour.length == 0) {
        //     setLastFourError('error')
        // } else if (email.length == 0) {
        //     setEmailError('error');
        // } else if (password.length == 0) {
        //     setPasswordError('error');
        // } else if (confirmPassword.length == 0) {
        //     setConfirmPasswordError('error');
        // } else if (vendorCode.length == 0) {
        //     setVendorCodeError('error');
        // }

        let item = {
            FirstName: data.firstName,
            LastName: data.lastName,
            Title: data.title,
            DocumentType: selectedDoctype,
            Last4Digits: data.last4Digits,
            Email: data.email,
            Password: data.createPassword,
            ConfirmPassword: data.confirmPassword,
            VendorCode: data.vendorCode,

            //   Title: "Test",
            //   DocumentType: 0,
            //   Last4Digits: "string",
            //   Email: "apanwar@ahaapps.com",
            //   Password: "Teeeest#123",
            //   ConfirmPassword: "Teeeest#123",
            //   VendorCode: "15524938",
            //   IsSuccess: true
        }
        axios.post(BaseUrl.baseUrl + BaseUrl.registration.employeeRegistration, item, BaseUrl.apiHeaders).then(response => {
            if (response.data.responseCode == "-200") {
                setOpenError(true);
            } else if (response.data.responseCode == "100") {
                setOpen(true);
            } else {
                setOpenError(true);
            }
        })
        console.log(item);
    }

    // const handleClose = (event, reason) => {
    //     if (reason === 'clickaway') {
    //         return;
    //     }
    //     setOpen(false);
    //     setOpenError(false);
    // };

    return (
        <>
            <div className='first-verify__registerationContainer'>
                <Button variant="outlined" className="login-button-backtologin" onClick={() => navigate("/")}><ArrowBackIcon />Back to Login</Button>
                <div className='first-verify__inputContainer'>
                    <div className='first-verify__logo'></div>

                    {/* <Snackbar open={open} autoHideDuration={6000} onClose={handleClose}>
                        <Alert onClose={handleClose} severity="success" sx={{ width: '100%' }}>
                            {props.content.employeeRegistration.successfulRegistration}
                        </Alert>
                    </Snackbar>
                    <Snackbar open={openError} autoHideDuration={6000} onClose={handleClose}>
                        <Alert severity="error" onClose={handleClose} >{props.content.employeeRegistration.completeFields}</Alert>
                    </Snackbar> */}

                    <h1 className='employee-registration'>{props.content.employeeRegistration.heading}</h1>
                    <div className='formControl-container'>
                        <span className='username-label'>{props.content.employeeRegistration.firstName}<span className="asterisk-red">*</span></span>
                        <TextField id="outlined-basic" sx={{
                            '& legend': { display: 'none' },
                            '& fieldset': { top: 0 },
                            "height": 50,
                        }} inputProps={{ className: "login-user" }} error={errors.firstName ? true : false}  {...register('firstName')} placeholder={props.content.employeeRegistration.firstName} variant="outlined" required />
                        <Typography className='asterisk-red'>
                            {errors.firstName?.message}
                        </Typography>
                    </div>
                    <div className='formControl-container'>
                        <span className='username-label'>{props.content.employeeRegistration.lastName}<span className="asterisk-red">*</span></span>
                        <TextField id="outlined-basic" sx={{
                            '& legend': { display: 'none' },
                            '& fieldset': { top: 0 },
                            "height": 50,
                        }}   {...register('lastName')} inputProps={{ className: "login-user" }} error={errors.lastName ? true : false} placeholder={props.content.employeeRegistration.lastName} variant="outlined" required />
                        <Typography className='asterisk-red'>
                            {errors.lastName?.message}
                        </Typography>
                    </div>
                    <div className='formControl-container'>
                        <span className='username-label'>{props.content.employeeRegistration.title}<span className="asterisk-red">*</span></span>
                        <TextField id="outlined-basic" sx={{
                            '& legend': { display: 'none' },
                            '& fieldset': { top: 0 },
                            "height": 50,
                        }}   {...register('title')} inputProps={{ className: "login-user" }} error={errors.title ? true : false} placeholder={props.content.employeeRegistration.title} variant="outlined" required />
                        <Typography className='asterisk-red'>
                            {errors.title?.message}
                        </Typography>
                    </div>
                    <div className='formControl-container'>
                        <span className='username-label'>{props.content.employeeRegistration.documentType}<span className="asterisk-red">*</span></span>

                        <Select id="outlined-basic"
                            required
                            sx={{
                                '& legend': { display: 'none' },
                                '& fieldset': { top: 0 },
                                "height": 50,
                            }}
                            placeholder="Select DocumentType"
                            variant="outlined"
                            value={selectedDoctype}
                            onChange={handleChange}
                            style={{ width: "100%" }}
                        >
                            {docType.map((item, index) => (
                                <MenuItem key={index} value={item.value}>
                                    {item.value}
                                </MenuItem>
                            ))}
                        </Select>

                        {/* <Select
                            multiple
                            value={selectedDoctype}
                            onChange={handleChange}
                            renderValue={(selected) => {
                                if (selected.length === 0) {
                                    return <em>Select</em>;
                                }

                                return selected.join(', ');
                            }}
                        >
                            <MenuItem disabled value="">
                                <em>Placeholder</em>
                            </MenuItem>
                            {docType.map((item, index) => (
                                <MenuItem key={index} value={item.key}>
                                    {item.key}
                                </MenuItem>
                            ))}
                        </Select> */}

                    </div>
                    <div className='formControl-container'>
                        <span className='username-label'>{props.content.employeeRegistration.last4Digits}<span className="asterisk-red">*</span></span>
                        <TextField id="outlined-basic" sx={{
                            '& legend': { display: 'none' },
                            '& fieldset': { top: 0 },
                            "height": 50,
                        }}    {...register('last4Digits')} inputProps={{ className: "login-user" }} error={errors.last4Digits ? true : false} placeholder={props.content.employeeRegistration.last4Digits} variant="outlined" required />
                        <Typography className='asterisk-red'>
                            {errors.last4Digits?.message}
                        </Typography>
                    </div>
                    <div className='formControl-container'>
                        <span className='username-label'>{props.content.employeeRegistration.email}<span className="asterisk-red">*</span></span>
                        <TextField id="outlined-basic" sx={{
                            '& legend': { display: 'none' },
                            '& fieldset': { top: 0 },
                            "height": 50,
                        }}   {...register('email')} placeholder={props.content.employeeRegistration.email} inputProps={{ className: "login-user" }} error={errors.email ? true : false} variant="outlined" required />
                        <Typography className='asterisk-red'>
                            {errors.email?.message}
                        </Typography>
                    </div>
                    <div className='formControl-container'>
                        <span className='username-label'>{props.content.employeeRegistration.number}<span className="asterisk-red">*</span></span>
                        <TextField id="outlined-basic" sx={{
                            '& legend': { display: 'none' },
                            '& fieldset': { top: 0 },
                            "height": 50,
                        }}   {...register('number')} inputProps={{ className: "login-user" }} placeholder={props.content.employeeRegistration.number} error={errors.number ? true : false} variant="outlined" required />
                        <Typography className='asterisk-red'>
                            {errors.number?.message}
                        </Typography>
                    </div>
                    <div className='formControl-container'>
                        <span className='username-label'>{props.content.employeeRegistration.createPassword}<span className="asterisk-red">*</span></span>
                        <TextField id="outlined-basic" sx={{
                            '& legend': { display: 'none' },
                            '& fieldset': { top: 0 },
                            "height": 50,
                        }} type="password" {...register('createPassword')} inputProps={{ className: "login-user" }} placeholder={props.content.employeeRegistration.createPassword} error={errors.createPassword ? true : false} variant="outlined" required />
                        <Typography className='asterisk-red'>
                            {errors.createPassword?.message}
                        </Typography>
                    </div>
                    <div className='formControl-container'>
                        <span className='username-label'>{props.content.employeeRegistration.confirmPassword}<span className="asterisk-red">*</span></span>
                        <TextField id="outlined-basic" sx={{
                            '& legend': { display: 'none' },
                            '& fieldset': { top: 0 },
                            "height": 50,
                        }} type="password"  {...register('confirmPassword')} inputProps={{ className: "login-user" }} placeholder={props.content.employeeRegistration.confirmPassword} error={errors.confirmPassword ? true : false} variant="outlined" required />
                        <Typography className='asterisk-red'>
                            {errors.confirmPassword?.message}
                        </Typography>
                    </div>
                    <div className='formControl-container'>
                        <span className='username-label'>{props.content.employeeRegistration.vendorCode}<span className="asterisk-red">*</span></span>
                        <TextField id="outlined-basic" sx={{
                            '& legend': { display: 'none' },
                            '& fieldset': { top: 0 },
                            "height": 50,
                        }}  {...register('vendorCode')} inputProps={{ className: "login-user" }} placeholder={props.content.employeeRegistration.vendorCode} error={errors.vendorCode ? true : false} variant="outlined" required />
                        <Typography className='asterisk-red'>
                            {errors.vendorCode?.message}
                        </Typography>
                    </div>
                    <div className='formControl-container'>
                        <Button variant="contained" className="login-button" sx={{ padding: "15px", textTransform: "capitalize" }} onClick={handleSubmit(onSubmit)}>{props.content.employeeRegistration.createAccount}</Button>
                    </div>
                </div>
                <Footer />
            </div>
        </>
    )
}

export default Registeration;